export default __webpack_public_path__ + "static/media/blink.33b69b3d.svg";